
<div class="course-list">
    <div class="blur-container">
        <h2 class="module-title">Для вас доступны</h2>
        <div class="blur-filter"></div>
    </div>

    <div class="block" #blockElement>
        <div class="container-shadow">
            <div class="container">
                <div class="accordion-item" #blockElement>
                    <div class="accordion-header">
                        <mat-icon class="icon icon-course-list"svgIcon="course-list"></mat-icon>
                        <h3 class="accordion-header-title">Циклы обучения:</h3>
                    </div>

                    <div class="accordion-body">
                        <ng-container *ngIf="courses?.length">
                            <div class="accordion-body-item" *ngFor="let course of courses">
                                <a class="menu-container step-link"  [routerLink]="['/', course.id]">
                                    <p class="menu-container-p">{{course?.name}}</p>
                                    <div class="menu-right">
                                        <div  class="zet">
                                            <span>{{course?.zet}}</span>
                                            <span class="zet-text">ЗЕТ</span>
                                        </div>
                                        <div  class="dates">
                                            <span>{{course?.startDate}}</span>
                                            <span>{{course?.endDate}}</span>
                                        </div>
                                        <div class="arrow">
                                            <mat-icon class="arrow-icon first" svgIcon="sort-up"></mat-icon>
                                        </div>
                                    </div>
                                </a>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>